import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { adminMemberProfileApi } from "@/lib/admin-member-profile-api"
import { activityPointsKeys, adminMembersKeys } from "@/lib/query-keys"

export const useAdminMemberProfileQuery = (memberId: string) =>
  useQuery({
    queryKey: adminMembersKeys.detail(memberId),
    queryFn: () => adminMemberProfileApi.get(memberId),
  })

export const useDeactivateMemberMutation = (memberId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (note: string) =>
      adminMemberProfileApi.deactivate(memberId, note),
    onSuccess: async (profile) => {
      queryClient.setQueryData(adminMembersKeys.detail(memberId), profile)
      await queryClient.invalidateQueries({ queryKey: activityPointsKeys.all })
    },
  })
}

export const useSetMemberJoinDateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      memberId,
      joinedDate,
    }: {
      memberId: string
      joinedDate: string | null
    }) => adminMemberProfileApi.setJoinDate(memberId, joinedDate),
    onSuccess: async (profile, { memberId }) => {
      queryClient.setQueryData(adminMembersKeys.detail(memberId), profile)
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: activityPointsKeys.all }),
        queryClient.invalidateQueries({ queryKey: ["profile", memberId] }),
      ])
    },
  })
}
